@if(productTourService.productTourRunning$ | async) {
  <div class="overlay" [@fadeInOut] data-cy="product-tour-background" (click)="productTourService.endTour()"></div>
}

